export default {
  GET_ASSISTANT_AMANGER_DATATABLE: 'GET_ASSISTANT_AMANGER_DATATABLE',
  GET_REMAINING_MANAGER_LIST: 'GET_REMAINING_MANAGER_LIST'
}
